import { render, staticRenderFns } from "./WidgetEditable.vue?vue&type=template&id=bb4b317a&"
import script from "./WidgetEditable.vue?vue&type=script&lang=js&"
export * from "./WidgetEditable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports